import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footerGrid}>

          {/* Solutions — spans 2 columns */}
          <div className={styles.footerGroup}>
            <h4>Solutions</h4>
            <div className={styles.footerGroupCols}>
              <ul>
                <li><a href="/solutions/dental">Dental Agent</a></li>
                <li><a href="/solutions/restaurant">Restaurant Agent</a></li>
                <li><a href="/solutions/medical">Medical Agent</a></li>
              </ul>
              <ul>
                <li><a href="/solutions/general">General Agent</a></li>
                <li><a href="/solutions/custom">Custom Agent</a></li>
              </ul>
            </div>
          </div>

          {/* Company — spans 2 columns */}
          <div className={styles.footerGroup}>
            <h4>Company</h4>
            <div className={styles.footerGroupCols}>
              <ul>
                <li><a href="/about">About</a></li>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
              <ul>
                <li><a href="/#faq">FAQ</a></li>
                <li><a href="/#pricing">Pricing</a></li>
                <li><a href="/partners">Partners</a></li>
              </ul>
            </div>
          </div>

          {/* Resources */}
          <div className={styles.footerCol}>
            <h4>Resources</h4>
            <ul>
              <li><a href="/docs">Documentation</a></li>
              <li><a href="/login">Support</a></li>
              <li><a href="/security">Security</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className={styles.footerCol}>
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Service</a></li>
            </ul>
          </div>

        </div>
        <div className={styles.footerBottom}>
          <p>© 2026 NovaMind AI Inc. All rights reserved.</p>
          <div className={styles.footerSocial}>
            <a href="#">Instagram</a>
            <a href="#">Facebook</a>
            <a href="#">TikTok</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
